<template>
<div>

    <b-nav-item-dropdown right toggle-class="d-flex align-items-center dropdown-user-link" class="dropdown-user">
        <template #button-content>
            <div class="d-sm-flex user-nav">
                <p class="user-name font-weight-bolder mb-0">
                    {{ userData.fullName.toUpperCase() || userData.username.toUpperCase() }}
                </p>
                <span class="user-status">
                    <b-badge variant="light-primary">{{ userData.group_name.toUpperCase() }}</b-badge>
                </span>
            </div>

            <feather-icon v-if="!userData.fullName" icon="UserIcon" size="22" />
            </b-avatar>
        </template>
        <!--
    <b-dropdown-item
      :to="{ name: 'pages-profile'}"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="UserIcon"
        class="mr-50"
      />
      <span>Profile</span>
    </b-dropdown-item>

    <b-dropdown-divider />
-->
        <b-form-group :label="$t('Idle Logout Time')" class="px-1 py-25" label-for="Status">
            <v-select v-model="idle_timeout_minutes" :options="timeOptions" :reduce="val => val.value" :clearable="false" />
            <b-badge class="mt-1 d-block">
                {{$t("Idle Time")}} :
                {{ Math.floor(idleSeconds / 60) }} {{$t("Minutes") }}
                {{ idleSeconds % 60 }} 秒
            </b-badge>

        </b-form-group>

        <b-dropdown-divider />
        <b-dropdown-item link-class="d-flex align-items-center" v-b-modal.modal-prevent-closing>
            <feather-icon size="16" icon="KeyIcon" class="mr-50" />
            <span>{{$t('Change Password')}}</span>
        </b-dropdown-item>

        <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
            <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
            <span>{{$t('Logout')}}</span>
        </b-dropdown-item>
    </b-nav-item-dropdown>
    <b-modal id="modal-prevent-closing" ref="my-modal" title="輸入你的新密碼 Submit Your New Password" ok-title="Submit" cancel-variant="outline-secondary" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit">
            <b-form-group :state="nameState" label="現有密碼 Exist Password" label-for="name-input" invalid-feedback="Password is required">
                <b-form-input id="password-input" type="password" v-model="exist_password" rules="required|password" required />
            </b-form-group>
            <b-form-group :state="nameState" label="新密碼 New Password" label-for="name-input" invalid-feedback="Password is required">
                <b-form-input id="password-input" type="password" v-model="password" rules="required|password" required />
            </b-form-group>
            <b-form-group :state="nameState" label="重複新密碼 New Password" label-for="name-input" invalid-feedback="Password is required">
                <b-form-input id="password-input" type="password" v-model="confirm_password" rules="required|password" required />
            </b-form-group>
        </form>
    </b-modal>
</div>
</template>

<script>
import {
    BNavItemDropdown,
    BBadge,
    BDropdownItem,
    BDropdownDivider,
    VBModal,
    BAvatar,
    BButton,
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
} from 'bootstrap-vue'
import {
    avatarText
} from '@core/utils/filter'
import {
    initialAbility
} from '@/libs/acl/config'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'

import useJwt from '@/auth/jwt/useJwt'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
    watch
} from 'vue'
export default {
    directives: {
        Ripple,
    },
    components: {
        BNavItemDropdown,
        BDropdownItem,
        BDropdownDivider,
        vSelect,
        BAvatar,
        BButton,
        BBadge,
        VBModal,
        BModal,
        BForm,
        ToastificationContent,
        BFormInput,
        BFormGroup,
    },
    data() {
        return {
            idle_timeout_minutes: 15,
            idleSeconds: 0, // 👈 已 idle 秒數
            counter: 0, // （optional）剩餘分鐘顯示用
            timer: null, // ✅ 關鍵
            countdownSeconds: 0, // ✅ 當前倒數秒
            timeOptions: [
              {
                    label: '1 Minutes',
                    value: 1
                },  
              {
                    label: '15 Minutes',
                    value: 15
                },
                {
                    label: '30 Minutes',
                    value: 30
                },
                {
                    label: '60 Minutes',
                    value: 60
                },
                {
                    label: '180 Minutes',
                    value: 180
                },
                {
                    label: '360 Minutes',
                    value: 360
                },
            ],
            userData: JSON.parse(localStorage.getItem('userData')),
            avatarText,
            password: null,
            nameState: null,
            confirm_password: null,
            exist_password: null
        }
    },
    mounted() {
  const events = [ 'keydown', 'click', 'scroll', 'touchstart']

  events.forEach(event => {
    window.addEventListener(event, this.resetIdle)
  })
},
beforeDestroy() {
  const events = [ 'keydown', 'click', 'scroll', 'touchstart']

  events.forEach(event => {
    window.removeEventListener(event, this.resetIdle)
  })

  this.stopCountdown()
},

    created() {
        this.startCountdown(this.userData.idle_timeout_minutes)
        if (this.userData.client_id == 10) {
            console.log("valleyFit Detect")
            this.logout()
        }
        var date = Math.round(new Date().getTime() / 1000)
        if (this.userData.expire) {
            if (this.userData.expire < date) {
                this.$forceUpdate();
                this.logout()
            }
        } else {
            this.$forceUpdate();
            this.logout()
        }
        if (this.userData.client_expired === true) {
            this.showToast("danger", "Your CloudFit account expired on " + this.userData.client_expire_date, 9999999)
        }
    },
    watch: {
        idle_timeout_minutes(newVal) {
            this.startCountdown(newVal) // 🔥 已經會自動 stop 舊 timer
        }
    },

    methods: {
      resetIdle() {
    this.idleSeconds = 0
    this.countdownSeconds = this.idle_timeout_minutes * 60
  },
        startCountdown(minutes) {
          //  console.log('⏱ Start idle countdown:', minutes, 'minutes')

            // 🔥 保險：先停舊 timer
            this.stopCountdown()

            this.idleSeconds = 0
            this.countdownSeconds = minutes * 60

            this.timer = setInterval(() => {
           //   console.log('⏳ Idle countdown:', this.countdownSeconds, 'seconds left')
                this.countdownSeconds--
                this.idleSeconds++

                this.counter = Math.floor(this.idleSeconds / 60)

                if (this.countdownSeconds <= 0) {
                    this.stopCountdown()

                    this.$swal({
                        icon: 'warning',
                        title: 'Idle Timeout 閒置超時',
                        html: 'You have been idle for too long.<br>您已經閒置太久。',
                        timer: 30000,
                        timerProgressBar: true,
                        showConfirmButton: true,
                        confirmButtonText: 'Continue 繼續使用',
                    }).then(result => {
                        if (!result.isConfirmed) {
                            this.logout()
                        } else {
                            // 繼續用 → 重新開始
                            this.startCountdown(this.idle_timeout_minutes)
                        }
                    })
                }
            }, 1000)
        },

        stopCountdown() {
            if (this.timer) {
                clearInterval(this.timer)
                this.timer = null
                console.log('⏹ Countdown stopped')
            }
        },

        // Timer
        showToast(variant, message, timeout) {
            this.$toast({
                component: ToastificationContent,
                draggable: true,
                draggablePercent: 100,
                props: {
                    title: 'Account Expired',
                    icon: 'BellIcon',
                    hideClose: true,
                    text: message,
                    variant,
                    position: 'top-center',
                    draggable: true,
                    draggablePercent: 100,
                },
            }, {
                id: 'expire_alert',
                draggable: true,
                draggablePercent: 100,
                timeout,
                position: 'top-center',
            })
        },
        checkFormValidity() {
            const valid = this.$refs.form.checkValidity()
            this.nameState = valid

            return valid
        },
        handleOk(bvModalEvt) {
            // Prevent modal from closing
            bvModalEvt.preventDefault()
            // Trigger submit handler
            this.handleSubmit()
        },
        handleSubmit() {
            // Exit when the form isn't valid
            if (!this.checkFormValidity()) {
                return
            }
            if (this.password != this.confirm_password) {
                this.$toast({
                    component: ToastificationContent,
                    position: 'top-center',
                    props: {
                        title: 'Error',
                        icon: 'XIcon',
                        variant: 'danger',
                        text: '輸入的密碼不一致'
                    },
                })
                return false
            }
            this.$http.post(process.env.VUE_APP_API_BASE + '/staff/password/', {
                    'password': this.password,
                    'exist_password': this.exist_password,
                })
                .then(res => {
                    if (res.data.result === true) {
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-center',
                            props: {
                                title: 'Success',
                                icon: 'CheckIcon',
                                variant: 'success',
                                text: res.data.message,
                            },
                        })
                        this.password = null
                        this.exist_password = null
                        this.confirm_password = null
                        this.$refs['my-modal'].hide()
                    } else {
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-center',
                            props: {
                                title: 'Error',
                                icon: 'XIcon',
                                variant: 'danger',
                                text: res.data.message,
                            },
                        })
                    }
                })

        },
        logout() {
            this.$http.post(process.env.VUE_APP_API_BASE + '/logout/', {
                socket_id: localStorage.getItem('socket_id')
            })
             this.$store.commit('member_search/UPDATE_KEYWORD', '')
            this.$store.commit('member_search/UPDATE_PAGE', 1)
            
            localStorage.removeItem('whatsapp_id')
            window.dispatchEvent(new Event('whatsapp-logout'))

            localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
            localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)
            delete this.$http.defaults.headers.Token
            delete this.$http.defaults.headers.Authorization
            // Remove userData from localStorage
            localStorage.removeItem('userData')
            this.$toast.dismiss('expire_alert')
            // Reset ability
            this.$ability.update(initialAbility)

            // Redirect to login page
            this.$router.push({
                name: 'auth-login'
            })
        },
    },
}
</script>
